import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'
import { CartUser } from '@/types/cart'

const SEARCH_USERS = gql`
  query ($input: SearchUsersInput!) {
    searchUsers(input: $input) {
      id
      name
      email
      phoneNumber
    }
  }
`

interface SearchUsersResponse {
  searchUsers: CartUser
}

export const useSearchUsersApi = (email?: string): UseQueryResult<CartUser, Error> => {
  const client = useGraphQLClient()

  const searchUsers = async (): Promise<CartUser> => {
    const data = await client.request<SearchUsersResponse>(SEARCH_USERS, { input: { email } })

    return data.searchUsers
  }

  return useQuery<CartUser, Error>({
    queryKey: ['searchUsers', email],
    queryFn: searchUsers,
    enabled: !!email,
  })
}
